import { createClient } from "@openauthjs/openauth/client";

const issuer =
  import.meta.env.VITE_AUTH_URL ??
  (import.meta.env.DEV ? "http://localhost:8610" : "https://auth.pahcertificar.com");

export const authClient = createClient({
  clientID: "pahcertificar-app",
  issuer,
});

export const REDIRECT_URI = `${window.location.origin}/auth/callback`;

const TOKEN_KEY = "pahcertificar.app.tokens";
const CHALLENGE_KEY = "pahcertificar.app.challenge";
const POST_AUTH_PATH_KEY = "pahcertificar.app.post_auth_path";

export type Tokens = { access: string; refresh: string };

export function loadTokens(): Tokens | null {
  try {
    const raw = localStorage.getItem(TOKEN_KEY);
    return raw ? (JSON.parse(raw) as Tokens) : null;
  } catch {
    return null;
  }
}

export function saveTokens(tokens: Tokens) {
  localStorage.setItem(TOKEN_KEY, JSON.stringify(tokens));
}

export function clearTokens() {
  localStorage.removeItem(TOKEN_KEY);
}

export function saveChallenge(challenge: unknown) {
  sessionStorage.setItem(CHALLENGE_KEY, JSON.stringify(challenge));
}

export function takeChallenge(): { verifier: string; state: string } | null {
  const raw = sessionStorage.getItem(CHALLENGE_KEY);
  sessionStorage.removeItem(CHALLENGE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function savePostAuthPath(path: string) {
  const url = new URL(path, window.location.origin);
  if (url.origin !== window.location.origin) return;
  sessionStorage.setItem(
    POST_AUTH_PATH_KEY,
    `${url.pathname}${url.search}${url.hash}`
  );
}

export function takePostAuthPath(): string {
  const path = sessionStorage.getItem(POST_AUTH_PATH_KEY);
  sessionStorage.removeItem(POST_AUTH_PATH_KEY);
  return path?.startsWith("/") && !path.startsWith("//") ? path : "/";
}
